import { Observable } from "rxjs";

import { FacturaContentModel, FacturaModel } from "../factura.model";
import { HttpResponse } from "@angular/common/http";
import { FacturaCambioEstadoModel } from "../factura-cambio-estado.model";

export abstract class FacturaGateway {
    abstract findAll(page?: number, size?: number, data?: string, option?: string, estado?: string): Observable<FacturaModel>;
    abstract export(data?: string, option?: string): Observable<HttpResponse<Blob>>;
    abstract findByNumero(data: string | null): Observable<FacturaContentModel>;
    abstract cambiarEstado(facturaCambioEstadoModel:FacturaCambioEstadoModel): Observable<FacturaContentModel>;
}